import { api } from '@/api';
import {
  CreateKgWpChecklistTemplateRequest,
  CreateWorkPackageColumnDefRequest,
  KgWpChecklistTemplate,
  UpdateKgWpChecklistTemplateRequest,
  UpdateWorkPackageColumnDefRequest,
  WorkPackageColumnDef,
} from '@/features/work-packages/types';

const BASE = 'v1/work-packages';

export const getWpColumnDefs = async (tenderId: string) => {
  const { data } = await api.get<WorkPackageColumnDef[]>(`${BASE}/column-defs`, {
    params: { tenderId },
  });
  return data;
};

export const createWpColumnDef = async (
  tenderId: string,
  payload: CreateWorkPackageColumnDefRequest,
) => {
  const { data } = await api.post<WorkPackageColumnDef>(`${BASE}/column-defs`, payload, {
    params: { tenderId },
  });
  return data;
};

export const updateWpColumnDef = async (
  tenderId: string,
  columnDefId: string,
  payload: UpdateWorkPackageColumnDefRequest,
) => {
  const { data } = await api.put<WorkPackageColumnDef>(
    `${BASE}/column-defs/${columnDefId}`,
    payload,
    { params: { tenderId } },
  );
  return data;
};

export const deleteWpColumnDef = (tenderId: string, columnDefId: string) =>
  api.delete(`${BASE}/column-defs/${columnDefId}`, { params: { tenderId } });

export const getKgChecklistTemplates = async (organizationId: string) => {
  const { data } = await api.get<KgWpChecklistTemplate[]>(`${BASE}/checklist-templates`, {
    params: { organizationId },
  });
  return data;
};

export const createKgChecklistTemplate = async (
  organizationId: string,
  payload: CreateKgWpChecklistTemplateRequest,
) => {
  const { data } = await api.post<KgWpChecklistTemplate>(`${BASE}/checklist-templates`, payload, {
    params: { organizationId },
  });
  return data;
};

export const updateKgChecklistTemplate = async (
  organizationId: string,
  templateId: string,
  payload: UpdateKgWpChecklistTemplateRequest,
) => {
  const { data } = await api.put<KgWpChecklistTemplate>(
    `${BASE}/checklist-templates/${templateId}`,
    payload,
    { params: { organizationId } },
  );
  return data;
};

export const deleteKgChecklistTemplate = (organizationId: string, templateId: string) =>
  api.delete(`${BASE}/checklist-templates/${templateId}`, { params: { organizationId } });
